import {appendSuffix} from './appendSuffix';

interface TestIdProps {
  'data-testid'?: string;
}

export function suffixTestId<T extends TestIdProps>(suffix: string, testIdProps: T): string {
  return appendSuffix(suffix, testIdProps['data-testid']);
}
